// Copyright (c) Docugami, Inc. All rights reserved.

import { Component, ComponentId } from "sdv/engine/Component";
import { RenderBox } from "./ChunkRenderComponent";
import { ChunkStructure } from "store/dgml/dgmlTypes";

export interface TableChunkRenderComponent extends Component {
    typeId: ComponentId.TableChunkRender;
    structure: ChunkStructure;
    boxes?: RenderBox[];
    columnBoxes?: RenderBox[];
}

export function createTableChunkRenderComponent(tableStructure: ChunkStructure): TableChunkRenderComponent {
    return {
        typeId: ComponentId.TableChunkRender,
        structure: tableStructure
    }
}
